// Suppress ResizeObserver loop errors
// This is a known issue with ResizeObserver and carousels/responsive components
// The error is harmless but can be annoying in development

const suppressResizeObserverError = () => {
  const resizeObserverLoopErrRe = /^[^(]*ResizeObserver loop/;
  const resizeObserverLoopLimitErrRe = /^[^(]*ResizeObserver loop limit exceeded/;
  const resizeObserverErrRe = /ResizeObserver/;

  // Suppress errors in console.error
  const originalError = window.console.error;
  window.console.error = (...args) => {
    const errorMessage = args[0]?.toString() || '';
    if (
      resizeObserverLoopErrRe.test(errorMessage) ||
      resizeObserverLoopLimitErrRe.test(errorMessage) ||
      resizeObserverErrRe.test(errorMessage)
    ) {
      // Suppress ResizeObserver errors - they're harmless
      return;
    }
    originalError.apply(window.console, args);
  };

  // Also suppress uncaught errors
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (typeof message === 'string' && resizeObserverErrRe.test(message)) {
      return true; // Suppress the error
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Suppress unhandled promise rejections related to ResizeObserver
  window.addEventListener('error', (event) => {
    if (event.message && resizeObserverErrRe.test(event.message)) {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
  }, true);

  // Suppress unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && typeof event.reason === 'string' && resizeObserverErrRe.test(event.reason)) {
      event.preventDefault();
      return true;
    }
  });

  // Suppress React error overlay for ResizeObserver errors
  // Override the error handler that webpack-dev-server uses
  if (typeof window !== 'undefined' && window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__) {
    const originalOnError = window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__.onError;
    window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__.onError = function(err) {
      if (err && err.message && resizeObserverErrRe.test(err.message)) {
        return; // Don't show ResizeObserver errors in overlay
      }
      if (originalOnError) {
        return originalOnError.apply(this, arguments);
      }
    };
  }
};

export default suppressResizeObserverError;

